import React from "react";
import { Switch, Route } from "react-router-dom";
import * as routes from "constants/routes";

import NotificationsIndex from "containers/Notifications/NotificationsIndex";
import NotificationsCreate from "containers/Notifications/NotificationsCreate";
import NotificationsShow from 'containers/Notifications/NotificationsShow'

function NotificationsRoutes(props) {
  return (
    <Switch>
      <Route
        exact
        path={`${routes.NOTIFICATIONS}`}
        component={NotificationsIndex}
      />
      <Route
        path={`${routes.NOTIFICATIONS}/create`}
        component={NotificationsCreate}
      />
      <Route path={`${routes.NOTIFICATIONS}/:id/show`} component={NotificationsShow}/>
    </Switch>
  );
}

export default NotificationsRoutes;
